<template>
  <div >
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{ isNaN(parseInt(VALUE)) == true ? "%" + 0 : "%" + VALUE.toFixed(0) }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: ""
    };
  },
  created() {
    this.VALUE = this.params.value;
  }
};
</script>
